// 8 种主流语言：覆盖美洲（en/es）、欧洲（en/fr/de/es）、亚洲（zh-CN/zh-TW/ja/ko）。

export const LOCALES = ['en', 'zh-CN', 'zh-TW', 'ja', 'ko', 'es', 'fr', 'de'] as const;
export type Locale = (typeof LOCALES)[number];

export const LOCALE_LABELS: Record<Locale, string> = {
  en: 'English',
  'zh-CN': '简体中文',
  'zh-TW': '繁體中文',
  ja: '日本語',
  ko: '한국어',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
};

export const DEFAULT_LOCALE: Locale = 'en';

// 翻译键的形态：嵌套对象 → 用 'a.b.c' 路径取值
export type TranslationDict = Record<string, unknown>;
